var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 20,
    fill: "none",
    viewBox: "0 0 12 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.49 10q0 .564-.452 1.027l-8.792 8.59q-.18.19-.406.293-.238.09-.508.09a1.37 1.37 0 0 1-.677-.17 1.3 1.3 0 0 1-.474-.473A1.25 1.25 0 0 1 0 18.69a1.3 1.3 0 0 1 .406-.948l8.5-8.296v1.095l-8.5-8.285A1.3 1.3 0 0 1 0 1.31Q0 .937.18.643.35.35.656.181.96 0 1.332 0q.53 0 .914.384l8.792 8.589q.226.214.339.474t.113.553"
  })));
};
export default SvgArrowRight;